import { combineReducers } from "redux";
import walletConnection from "./walletConnection";
import getUsers from "./getUsers";

export default combineReducers({
  walletConnection,
  getUsers
});
